module.exports = __webpack_public_path__ + "static/Dona-Regular-80493c4c01d596f66349e1e4262cff98.woff";